import Edit from "./email-channel-edit-form";
import ConnectModal from "./email-channel-connect-modal";

const EmailChannelForms = { Edit, ConnectModal };

export default EmailChannelForms;
